/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IiIsImZpbGUiOiJzcmMvYXBwL3ByZXNlbnRhdGlvbi9wYWdlcy9tb25pdG9ycy9tb25pdG9yLWFkZC9tb25pdG9yLWFkZC1zdGVwLTEvbW9uaXRvci1hZGQtc3RlcC0xLmNvbXBvbmVudC5zY3NzIn0= */"];
export { styles as styles };
